import { useQuery, useMutation } from "react-query";
import { useInfiniteQuery } from "react-query";
import { queryClient } from "../../libs/react-query"
import { GET_USER, FIND_USER } from "../../constants/queryKeys";
import {
  findUser,
  getUsers,
  changePasswordUser,
  deleteUser,
  addUser,
  editUser,
} from "../apiClient/users";

const invalidateUserQuery = () => {
	queryClient.invalidateQueries(GET_USER);
};

const useGetUsers = ({ payload, config }) => {
	return useInfiniteQuery([GET_USER, payload], getUsers, config);
};
const useFindUser = ({ payload, config }) => {
	return useQuery([FIND_USER, payload], () => findUser(payload), config);
};
const useAddUser = (options) => {
	return useMutation((payload) => addUser(payload), options);
};
const useEditUser = (options) => {
	return useMutation((payload) => editUser(payload), options);
};
const useDeleteUser = (options) => {
	return useMutation((payload) => deleteUser(payload), options);
};
const useChangePasswordeUser = (options) => {
	return useMutation((payload) => changePasswordUser(payload), options);
};

export {
  useGetUsers,
  useAddUser,
  useEditUser,
  useDeleteUser,
  useFindUser,
  useChangePasswordeUser,
  invalidateUserQuery,
};
